import { render, staticRenderFns } from "./WagenbuchEreignis.vue?vue&type=template&id=31b10f2d&"
import script from "./WagenbuchEreignis.vue?vue&type=script&lang=js&"
export * from "./WagenbuchEreignis.vue?vue&type=script&lang=js&"
import style0 from "./WagenbuchEreignis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports